module.exports = __webpack_public_path__ + "static/img/587_phase_function_Paper_Points.94b820b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/587_phase_function_Paper_Points.png
// module id = IIuX
// module chunks = 0